import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminLayout from '../components/Admin/AdminLayout';
import './AdminForm.css';

const EditProduct = () => {
  const { id } = useParams();
  const [form, setForm] = useState({ name: '', description: '', category: '' });
  const [imageFile, setImageFile] = useState(null);
  const [existingImage, setExistingImage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`https://infuse-backend.onrender.com/api/products/${id}`)
      .then(res => res.json())
      .then(data => {
        setForm({ 
          name: data.name, 
          description: data.description, 
          category: data.category,
          featured: data.featured || false 
        });        
        setExistingImage(data.image);
      });
  }, [id]);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleFileChange = e => setImageFile(e.target.files[0]);

  const handleSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('description', form.description);
    formData.append('category', form.category);
    formData.append('featured', form.featured);
    if (imageFile) formData.append('image', imageFile);

    await fetch(`https://infuse-backend.onrender.com/api/products/${id}`, {
      method: 'PUT',
      body: formData,
      credentials: 'include'
    });

    navigate('/admin/dashboard');
  };

  return (
    <AdminLayout>
      <div className="admin-form-container">
        <h2>Edit Product</h2>
        <form className="admin-form" onSubmit={handleSubmit} encType="multipart/form-data">
          <label>Name:</label>
          <input name="name" value={form.name} onChange={handleChange} required />

          <label>Category:</label>
          <input name="category" value={form.category} onChange={handleChange} />

          <label>Current Image:</label>
          {existingImage && (
            <img src={`${existingImage}`} alt="Current" height="60" style={{ marginBottom: '10px', borderRadius: '4px' }} />
          )}

          <label>Change Image:</label>
          <input type="file" accept="image/*" onChange={handleFileChange} />

          <label>Description:</label>
          <textarea name="description" rows="4" value={form.description} onChange={handleChange} />

          <div className="form-checkbox">
            <input 
              type="checkbox" 
              id="featured" 
              name="featured" 
              checked={form.featured || false}
              onChange={(e) => setForm({...form, featured: e.target.checked})}
            />
            <label htmlFor="featured">Featured Product</label>
          </div>

          <button type="submit">Update Product</button>
        </form>
      </div>
    </AdminLayout>
  );
};

export default EditProduct;